// extracted by mini-css-extract-plugin
export default {"container":"nZEYV2","heading":"j0lDZR","instagram":"MhQAvj","accessibilityThemeContainer":"nWsEuL"};